// Single source for the weekly-rounds day map. Keys drive chip state; the
// full names feed moment().day(name), so they must be valid weekday names.
export const initialWeekDays = () => ({
  'Mon': [ 'Monday', false ],
  'Tue': [ 'Tuesday', false ],
  'Wed': [ 'Wednesday', false ],
  'Thu': [ 'Thursday', false ],
  'Fri': [ 'Friday', false ],
  'Sat': [ 'Saturday', false ],
  'Sun': [ 'Sunday', false ],
})
